module.exports = __webpack_public_path__ + "media/images/linkedin-d8a8552d.svg";